import styled from 'styled-components';

const VerticalDivider = styled('div')`
  background: ${({ $color }) => $color || 'var(--color-accent-secondary-weaker)'};
  height: ${({ $height }) => $height || '100%'};
  margin: ${({ $margin }) => $margin};
  width: 1px;
`;

export default VerticalDivider;
